<template>
	<div
		:class="['panel', 'schedule',
			isHeaderIndent ? 'mt-0 pt-1' : '',
			isFooterIndent ? 'mb-0 pb-1' : '',
		]"
	>
		<div class="container">
			<div
				v-if="isHeaderVisible"
				:class="[
					'panel_header',
					isBrand ? 'sk' : '',
				]"
			>
				<!-- Картинка-лого в блоке заголовка панели - справа -->
				<b-img-lazy
					v-if="block.background_image.src"
					class="shcedule_logo"
					:src="block.background_image.src"
					alt=""
				/>
				<div class="row align-items-end">
					<div class="col-12">
						<h2 v-if="block.block_title === null">
							Расписание {{ fetchedData.type_titles.title_genitive }}
						</h2>
						<h2 v-else>
							{{ block.block_title }}
						</h2>
					</div>
				</div>
				<!-- <nuxt-link class="panel_control" to="#"></nuxt-link> -->
			</div>

			<ul class="schedule_list">
				<li v-for="(item, index) in block.items" :key="index" class="row">
					<div class="col-12 col-sm-12 col-lg-5">
						<div class="schedule_title">
							<p class="description">
								{{ item.over_title }}
							</p>
							<h3>{{ item.title }}</h3>
							<p class="description">
								{{ item.sub_title }}
							</p>
							<!-- Картинка внутри блока расписания -->
							<b-img-lazy
								v-if="item.background_image.src"
								class="mt-3"
								:src="item.background_image.src"
								alt=""
							/>
						</div>
					</div>
					<div class="col-12 col-sm-12 col-lg-7">
						<div class="row schedule_data">
							<div class="col-12 col-sm-4">
								<div class="schedule_time">
									{{ item.time }}
								</div>
							</div>
							<div class="col-12 col-sm-8">
								<div
									v-for="(sub_item, index) in item.sub_items"
									:key="index"
									class="schedule_about"
								>
									<div class="title">
										{{ sub_item.title }}
									</div>
									<p class="description">
										{{ sub_item.content }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>

			<div
				v-if="isFooterVisible"
				class="panel_footer"
			>
				<div class="row">
					<div class="col-12">
						<dynamic-button
							:button="block.button"
							:block-id="block.id"
							:scenario="block.scenario"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '@/mixins/panel';

export default {
	name: 'PanelConferenceScheduleThree',
	mixins: [panel],
	props: ['block', 'fetchedData', 'index'],
};
</script>
<style lang="scss">
	@import "~/assets/styles/components/home/panel-schedule";
</style>

<i18n lang="yaml">
ru:
  schedule: "Расписание"
  registration-on: "Регистрация на"
en:
  schedule: "Schedule"
  registration-on: "Registration for the"
</i18n>
